import { request } from './core.api';
import type { TenantWelcomePageSummaryDto } from './tenant-welcome-pages.api';

export interface TenantDto {
  id: string;
  tenantId?: string;
  propertyId: string;
  propertyAddress: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  rentAmount?: number;
  startDate?: string;
  endDate?: string;
  interestDate?: string;
  notes?: string;
  status: string;
  invitePending?: boolean;
  invitationSentAtUtc?: string;
  tenantPortalConnectionStatus?: string;
  hasRentomaxAccount?: boolean;
  hasTenantPortalLink?: boolean;
  matchedRentomaxProvider?: string;
  createdAt: string;
  updatedAt: string;
  welcomePage?: TenantWelcomePageSummaryDto | null;
}

export interface CreateTenantRequest {
  propertyId: string;
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  notes?: string;
  rentAmount: number;
  startDate: string;
  endDate?: string;
}

export interface UpdateTenantRequest {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  notes?: string;
}

export const tenantsApi = {
  getAll: () => request<TenantDto[]>('/tenants'),
  getByProperty: (propertyId: string) => request<TenantDto[]>(`/properties/${propertyId}/tenants`),
  getById: (id: string) => request<TenantDto>(`/tenants/${id}`),
  create: (data: CreateTenantRequest) => request<TenantDto>('/tenants', { method: 'POST', body: JSON.stringify(data) }),
  update: (id: string, data: UpdateTenantRequest) => request<TenantDto>(`/tenants/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  linkPortalAccount: (id: string) => request<TenantDto>(`/tenants/${id}/portal-link`, { method: 'POST', body: '{}' }),
  sendPortalInvite: (id: string, message?: string) => request<{ inviteUrl: string; invitationSentAtUtc: string }>(`/tenants/${id}/portal-invite`, { method: 'POST', body: JSON.stringify({ message }) }),
  delete: (id: string) => request<void>(`/tenants/${id}`, { method: 'DELETE' }),
};
